module.exports = __webpack_public_path__ + "australia.39d9f050.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/flags/australia.png
// module id = 1494
// module chunks = 0